import { render, staticRenderFns } from "./DashboardMealsTable.vue?vue&type=template&id=797d49d2"
import script from "./DashboardMealsTable.vue?vue&type=script&lang=js"
export * from "./DashboardMealsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports